"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconCalculatedRisks = function SvgIconCalculatedRisks(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "calculated risks icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Calculated Risks Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.347 18.61c.278.762.64 1.492 1.082 2.174 1.057 1.853 2.254 3.95 2.13 5.624v.207c.027.392-.073.783-.285 1.114a1.868 1.868 0 01-1.445.78c-.26.015-.547.015-.828.015a.75.75 0 00-.75.75v2.976a3.75 3.75 0 01-3.75 3.75h-2.25a.75.75 0 00-.75.75v4.5a.75.75 0 01-.75.75h-15a.75.75 0 01-.75-.75v-7.813a.75.75 0 00-.331-.623C9.908 30.281 8 26.344 8 21.094A14.887 14.887 0 0123.001 6c7.053 0 14.346 4.718 14.346 12.61zM27.18 21.263a.75.75 0 01.672-.283v-.006a4.5 4.5 0 00.9-8.952.75.75 0 01-.537-.323 4.477 4.477 0 00-6.989-.517.75.75 0 01-.735.217 5.024 5.024 0 00-1.239-.15 5.238 5.238 0 00-5.094 4.074.75.75 0 01-.234.395 6.535 6.535 0 00-2.172 4.906 6.202 6.202 0 006 6.375 5.952 5.952 0 005.273-3.376.75.75 0 01.586-.41 5.281 5.281 0 003.569-1.95z"
  }));
};

var _default = SvgIconCalculatedRisks;
exports.default = _default;